<template>
  <div class="tableStyle">
    <div class="tableBox">
      <div class="tableStyle-right">
        <div class="carStateTable">
          <el-scrollbar>
            <div class="rightAll">
              <div class="rightAll-form">
                <el-form
                  :inline="true"
                  :model="formInline"
                  class="demo-form-inline"
                >
                  <el-form-item :label="$t('TerminalFile.simIccicd')">
                    <el-input
                      size="mini"
                      v-model="formInline.simIccicd"
                      :placeholder="$t('common.searchTip')"
                      style="width: 150px"
                      class="input-with-select"
                    ></el-input>
                  </el-form-item>
                  <el-form-item :label="$t('VehicleManagement.simNumber')">
                    <el-input
                      size="mini"
                      v-model="formInline.simId"
                      :placeholder="$t('common.searchTip')"
                      style="width: 150px"
                      class="input-with-select"
                    ></el-input>
                  </el-form-item>
                  <el-form-item :label="$t('SIMFile.assetStatus')">
                    <el-select
                      v-model="formInline.assetState"
                      :placeholder="$t('common.all')"
                      size="mini"
                      style="width: 120px"
                    >
                      <el-option
                        v-for="item in typeList"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id"
                      ></el-option>
                    </el-select>
                  </el-form-item>
                  <el-form-item>
                    <el-button
                      size="mini"
                      type="primary"
                      @click="onSearch"
                      class="btn-chaxun"
                      >{{ $t("common.btn.search") }}</el-button
                    >
                    <el-button size="mini" @click="onClear" class="btn-del">{{
                      $t("common.btn.cancel")
                    }}</el-button>
                  </el-form-item>
                </el-form>
              </div>
              <div class="rightAll-btn">
                <!-- <el-button type="text" @click="refreshTerminal">{{
                  $t("common.btn.refresh")
                }}</el-button> -->
                <el-button
                  type="text"
                  :disabled="selected.length != 1"
                  @click="editTerminal"
                  >{{ $t("SIMFile.modifyRemarks") }}</el-button
                >
                <el-button
                  type="text"
                  :disabled="abandonedDisabled"
                  @click="abandonedTerminal"
                  >{{ $t("SIMFile.abandoned") }}</el-button
                >
                <el-button
                  type="text"
                  :disabled="selected.length == 0"
                  @click="deleteTerminal"
                  >{{ $t("common.btn.delete") }}</el-button
                >
                <el-button type="text" @click="addTerminal">{{
                  $t("common.btn.add")
                }}</el-button>
                <el-button type="text" @click="BulkImport">{{
                  $t("common.btn.batchUpload")
                }}</el-button>
                <el-button type="text" @click="downTerminal">{{
                  $t("common.btn.download")
                }}</el-button>
              </div>
              <i-table
                :list="list"
                :height="height"
                ref="carTable"
                @handleSelectionChange="handleSelectionChange"
                :options="option"
                :columns="columns"
                :operates="operates"
              ></i-table>
              <IPagination ref="page" @PageFun="changeSize"></IPagination>
            </div>
          </el-scrollbar>
        </div>
      </div>
      <el-dialog
        width="620px"
        :before-close="closeDia"
        class="addDialong"
        :title="diaTitle"
        :visible.sync="dialogFormVisible"
        :close-on-click-modal="false"
      >
        <el-form :rules="rules" ref="form" :model="form">
          <el-form-item
            v-if="isShow"
            prop="simIccicd"
            :label="$t('TerminalFile.simIccicd') + ':'"
            :label-width="formLabelWidth"
          >
            <el-input
              size="small"
              v-model="form.simIccicd"
              autocomplete="off"
              :disabled="disabled"
            ></el-input>
          </el-form-item>
          <el-form-item
            v-if="isShow"
            prop="supplier"
            :label="$t('ContractManagement.supplierName') + ':'"
            :label-width="formLabelWidth"
          >
            <el-input
              size="small"
              v-model="form.supplier"
              autocomplete="off"
              :disabled="disabled"
            ></el-input>
          </el-form-item>
          <el-form-item
            prop="remarks"
            :label="$t('DriverManagement.remarks') + ':'"
            :label-width="formLabelWidth"
            class="remarkStyle"
          >
            <el-input
              type="textarea"
              :rows="2"
              size="small"
              v-model="form.remarks"
              autocomplete="off"
            ></el-input>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button size="small" @click="cancle('form')">{{
            $t("common.btn.cancel")
          }}</el-button>
          <el-button size="small" type="primary" @click="submitForm('form')">{{
            $t("common.btn.confirm")
          }}</el-button>
        </div>
      </el-dialog>
      <el-dialog
        width="620px"
        :before-close="closeBatchDia"
        :title="$t('common.btn.batchUpload')"
        :visible.sync="dialogBatchFormVisible"
        class="batchDialong"
        :close-on-click-modal="false"
      >
        <div class="right-file">
          <el-button type="text" size="mini" @click="TemplateFile()">{{
            $t("common.btn.downloadModelFile")
          }}</el-button>
        </div>
        <div class="upload-file">
          <img src="../../../assets/images/upload.png" />
          <div>{{ $t("common.btn.clickUploadFile") }}</div>
          <input @change="uploadFile()" id="uploadDom" type="file" />
        </div>
        <div slot="footer" class="dialog-footer">
          <el-button @click="dialogBatchFormVisible = false" class="btn-del">{{
            $t("common.btn.cancel")
          }}</el-button>
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import SIMFile from "./SIMFile.js";
export default SIMFile;
</script>

<style lang="less" scoped>
@import "../../../assets/styles/Style.less";
// /deep/.el-table--border th.el-table__cell.gutter:last-of-type {
//   width: 0;
//   display: none;
// }
</style>
